module.exports = __webpack_public_path__ + "static/media/antigua-accommodation-11.8c94ed82.jpg";